// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CRIO_SOLUTION_START_MODULE_CHECKOUT */


/* CRIO_SOLUTION_END_MODULE_CHECKOUT */

p {
    margin-block-start: 0;
    margin-block-end: 0;
    margin-bottom: 1rem;
}

.greeting-container {
    min-height: 60vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 1rem;
    background-color: #DCFFE4;
}

#balance-overline {
    font-weight: 700;
    margin: 1rem 0 0.5rem 0;
}

#balance {
    font-weight: 700;
    font-size: 1.25rem;
}

#continue-btn {
    font-weight: 700;
    text-transform: none;
}

@media screen and (min-width: 768px) {
    .greeting-container {
        padding: 4rem;
    }
}

.action_buttons button {
    margin: 1rem;
    width: 90%;
}

.title {
    text-align: center;
    color: #000;
    font-weight: 600;
    font-size: 20px;
}

.iframe {
    margin: 0 10px;
    height: 300px;
    width: 200px;
    border: none;
    padding: 0;
    background-color: white;
}

body {
    margin: 0 !important
}`, "",{"version":3,"sources":["webpack://./src/components/Thanks.css"],"names":[],"mappings":"AAAA,wCAAwC;;;AAGxC,sCAAsC;;AAEtC;IACI,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI;AACJ","sourcesContent":["/* CRIO_SOLUTION_START_MODULE_CHECKOUT */\n\n\n/* CRIO_SOLUTION_END_MODULE_CHECKOUT */\n\np {\n    margin-block-start: 0;\n    margin-block-end: 0;\n    margin-bottom: 1rem;\n}\n\n.greeting-container {\n    min-height: 60vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 1rem;\n    background-color: #DCFFE4;\n}\n\n#balance-overline {\n    font-weight: 700;\n    margin: 1rem 0 0.5rem 0;\n}\n\n#balance {\n    font-weight: 700;\n    font-size: 1.25rem;\n}\n\n#continue-btn {\n    font-weight: 700;\n    text-transform: none;\n}\n\n@media screen and (min-width: 768px) {\n    .greeting-container {\n        padding: 4rem;\n    }\n}\n\n.action_buttons button {\n    margin: 1rem;\n    width: 90%;\n}\n\n.title {\n    text-align: center;\n    color: #000;\n    font-weight: 600;\n    font-size: 20px;\n}\n\n.iframe {\n    margin: 0 10px;\n    height: 300px;\n    width: 200px;\n    border: none;\n    padding: 0;\n    background-color: white;\n}\n\nbody {\n    margin: 0 !important\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
